import { arbitrum, avalanche, blast, bsc, optimism, base, polygon, mainnet } from 'viem/chains';
import { ChainId } from './networks';
import { ARBITRUM_RPC_URL, AVALANCHE_RPC_URL, BASE_RPC_URL, BLAST_RPC_URL, BSC_RPC_URL, ETHEREUM_RPC_URL, OPTIMISM_RPC_URL, POLYGON_RPC_URL, SOLANA_RPC_URL, } from './environment';
export var PROTOCOL_VERSION;
(function (PROTOCOL_VERSION) {
    PROTOCOL_VERSION["LEGACY"] = "legacy";
    PROTOCOL_VERSION["V2"] = "v2";
})(PROTOCOL_VERSION || (PROTOCOL_VERSION = {}));
export const NetworkStablecoins = new Map([
    [
        // TODO: @altloot Deploy ethereum changes
        ChainId.ETHEREUM,
        {
            address: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
            name: 'USD Coin',
            symbol: 'USDC',
            decimals: 6,
            oracle: '0x8fFfFfd4AfB6115b954Bd326cbe7B4BA576818f6',
            oracleChainId: ChainId.ETHEREUM,
        }, // USDC
    ],
    [
        ChainId.ARBITRUM,
        {
            address: '0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8',
            name: 'USD Coin (Arb1)',
            symbol: 'USDC',
            decimals: 6,
            oracle: '0x50834F3163758fcC1Df9973b6e91f0F0F0434aD3',
            oracleChainId: ChainId.ARBITRUM,
        },
    ], // USDC.e (Arbitrum Version)
    [
        ChainId.OPTIMISM,
        {
            address: '0x7F5c764cBc14f9669B88837ca1490cCa17c31607',
            name: 'USD Coin',
            symbol: 'USDC',
            decimals: 6,
            oracle: '0x16a9FA2FDa030272Ce99B29CF780dFA30361E0f3',
            oracleChainId: ChainId.OPTIMISM,
        },
    ], // USDC.e (Optimism Version)
    [
        ChainId.POLYGON,
        {
            address: '0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174',
            name: 'USD Coin (PoS)',
            symbol: 'USDC',
            decimals: 6,
            oracle: '0xfE4A8cc5b5B2366C1B58Bea3858e81843581b2F7',
            oracleChainId: ChainId.POLYGON,
        },
    ], // USDC (Polygon Version)
    [
        ChainId.BSC,
        {
            address: '0xe9e7cea3dedca5984780bafc599bd69add087d56',
            name: 'BUSD Token',
            symbol: 'BUSD',
            decimals: 18,
            oracle: '5bc91f13e412c07599167bae86f07543f076a638962b8d6017ec19dab4a82814', // Pyth
            oracleChainId: ChainId.BSC,
        },
    ], // BUSD
    [
        ChainId.AVALANCHE,
        {
            address: '0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E',
            name: 'USD Coin',
            symbol: 'USDC',
            decimals: 6,
            oracle: '0xF096872672F44d6EBA71458D74fe67F9a77a23B9',
            oracleChainId: ChainId.AVALANCHE,
        },
    ], // USDC
    [
        ChainId.BLAST,
        {
            address: '0x4300000000000000000000000000000000000003',
            name: 'USDB',
            symbol: 'USDB',
            decimals: 18,
            oracle: '41283d3f78ccb459a24e5f1f1b9f5a72a415a26ff9ce0391a6878f4cda6b477b', // Pyth
            oracleChainId: ChainId.BLAST,
        },
    ], // USDB
    // [
    //   ChainId.FANTOM,
    //   {
    //     address: '0x28a92dde19d9989f39a49905d7c9c2fac7799bdf' as Address,
    //     name: 'USD Coin',
    //     symbol: 'USDC',
    //     decimals: 6,
    //     oracle: '0x2553f4eeb82d5A26427b8d1106C51499CBa5D99c' as Address,
    //   },
    // ],
    [
        ChainId.SOLANA,
        {
            address: 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v',
            name: 'USD Coin',
            symbol: 'USDC',
            decimals: 6,
            oracle: '0xF096872672F44d6EBA71458D74fe67F9a77a23B9',
            oracleChainId: ChainId.AVALANCHE,
        },
    ],
    [
        ChainId.SOLANA_DLN,
        {
            address: 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v',
            name: 'USD Coin',
            symbol: 'USDC',
            decimals: 6,
            oracle: '0xF096872672F44d6EBA71458D74fe67F9a77a23B9',
            oracleChainId: ChainId.AVALANCHE,
        },
    ],
    [
        ChainId.SOLANA_DLN,
        {
            address: 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v',
            name: 'USD Coin',
            symbol: 'USDC',
            decimals: 6,
            oracle: '0xF096872672F44d6EBA71458D74fe67F9a77a23B9',
            oracleChainId: ChainId.AVALANCHE,
        },
    ],
    // USDC (Fantom/LZ Version)
    // [
    //   ChainId.MANTLE,
    //   {
    //     address: "0x09Bc4E0D864854c6aFB6eB9A9cdF58aC190D0dF9",
    //     name: "USD Coin",
    //     symbol: "USDC",
    //     decimals: 6,
    //     oracle:
    //       "eaa020c61cc479712813461ce153894a96a6c00b21ed0cfc2798d1f9a9e9c94a",
    //   },
    // ], // USDC
    // [
    //   ChainId.METIS,
    //   {
    //     address: "0xbB06DCA3AE6887fAbF931640f67cab3e3a16F4dC",
    //     name: "USDT Token",
    //     symbol: "m.USDT",
    //     decimals: 6,
    //     oracle:
    //       "2b89b9dc8fdf9f34709a5b106b472f0f39bb6ca9ce04b0fd7f2e971688e2e53b", // Pyth
    //   },
    // ], // m.USDT
    // [
    //   ChainId.MANTA,
    //   {
    //     address: "0xb73603C5d87fA094B7314C74ACE2e64D165016fb",
    //     name: "USD Coin",
    //     symbol: "USDC",
    //     decimals: 6,
    //     oracle:
    //       "eaa020c61cc479712813461ce153894a96a6c00b21ed0cfc2798d1f9a9e9c94a",
    //   },
    // ], // USDC
    [
        ChainId.BASE,
        {
            address: '0xd9aAEc86B65D86f6A7B5B1b0c42FFA531710b6CA',
            name: 'USD Base Coin',
            symbol: 'USDbC',
            decimals: 6,
            oracle: 'eaa020c61cc479712813461ce153894a96a6c00b21ed0cfc2798d1f9a9e9c94a',
            oracleChainId: ChainId.BASE,
        },
    ], // USDC (Base version)
]);
/**
 * Networks that need permit2 deployments:
 *  - Fantom
 *
 * Networks that need multicall with permit2 deployments:
 * - Ethereum
 * - BSC
 * - Polygon
 * - Fantom
 * - Arbitrum
 * - Optimism
 * - Blast
 * - Base
 *
 * Networks that have all deployments:
 * - Avalanche
 */
export const LegacyNetworks = {
    // [ChainId.MANTLE]: {
    //   name: "Mantle",
    //   nativeCurrency: "MNT",
    //   decimals: 18,
    //   rpcUrl: mantle.rpcUrls[0],
    //   nativeOracle: "0x0A77230d17318075983913bC2145DB16C7366156",
    //   permit2: "0x000000000022D473030F116dDEE9F6B43aC78BA3", // Placeholder
    //   chain: mantle,
    //   stargateId: 181,
    //   stargateRouter: "0x2F6F07CDcf3588944Bf4C42aC74ff24bF56e7590",
    //   poolId: 1,
    // },
    // [ChainId.METIS]: {
    //   name: "Metis",
    //   nativeCurrency: "METIS",
    //   decimals: 18,
    //   rpcUrl: metis.rpcUrls[0],
    //   nativeOracle: "0x0A77230d17318075983913bC2145DB16C7366156",
    //   permit2: "0x000000000022D473030F116dDEE9F6B43aC78BA3", // Placeholder
    //   chain: metis,
    //   stargateId: 151,
    //   stargateRouter: "0x2F6F07CDcf3588944Bf4C42aC74ff24bF56e7590",
    //   poolId: 19,
    // },
    // [ChainId.MANTA]: {
    //   name: "Manta",
    //   nativeCurrency: "MANTA",
    //   decimals: 18,
    //   rpcUrl: manta.rpcUrls[0],
    //   nativeOracle: "0x0A77230d17318075983913bC2145DB16C7366156",
    //   permit2: "0x000000000022D473030F116dDEE9F6B43aC78BA3", // Placeholder
    //   chain: manta,
    //   stargateId: 151,
    //   stargateRouter: "0x2F6F07CDcf3588944Bf4C42aC74ff24bF56e7590",
    //   poolId: 19,
    // },
    [ChainId.ETHEREUM]: {
        name: 'Ethereum',
        nativeCurrency: 'ETH',
        decimals: 18,
        rpcUrl: ETHEREUM_RPC_URL,
        permit2: '0x000000000022D473030F116dDEE9F6B43aC78BA3',
        chain: mainnet,
        stargateId: 101,
        stargateRouter: '0x8731d54E9D02c286767d56ac03e8037C07e01e98',
        poolId: 1,
        pool: '0xB820A29D82aD13b4B2aD8BF77ae586A13caa00DA',
        vault: '0x24E7d82cEfa9CE72d95A1CD4a3AE5F705249d3ea',
        executor: '0x39A32f31726950C550441EAe5bc290A6581FDEe3',
        nativeOracle: {
            address: '0x5f4eC3Df9cbd43714FE2740f5E3616155c5b8419',
            chainId: ChainId.ETHEREUM,
            decimals: 8,
        },
    },
    [ChainId.BSC]: {
        name: 'Binance Smart Chain',
        nativeCurrency: 'BNB',
        decimals: 18,
        rpcUrl: BSC_RPC_URL,
        nativeOracle: {
            address: '0x0567F2323251f0Aab15c8dFb1967E4e8A7D42aeE',
            chainId: ChainId.BSC,
            decimals: 8,
        },
        permit2: '0x000000000022D473030F116dDEE9F6B43aC78BA3',
        pool: '0xBD1B1e1f33f89D4beCd0E5c6D3E88bd447992134',
        vault: '0xDCF998011dcAab9B8C1Ea5B34f1b6c7bAF59d4C0',
        executor: '0x0d528865620B97832f8CEeC78A6dA3Ce8F170F65',
        chain: bsc,
        stargateId: 102,
        stargateRouter: '0x4a364f8c717cAAD9A442737Eb7b8A55cc6cf18D8',
        poolId: 5,
    },
    [ChainId.POLYGON]: {
        name: 'Polygon',
        nativeCurrency: 'MATIC',
        decimals: 18,
        rpcUrl: POLYGON_RPC_URL,
        nativeOracle: {
            address: '0xAB594600376Ec9fD91F8e885dADF0CE036862dE0',
            chainId: ChainId.POLYGON,
            decimals: 8,
        },
        permit2: '0x000000000022D473030F116dDEE9F6B43aC78BA3',
        pool: '0x185a5487F02A92d49E1911E475Bb192cAd0900EE',
        vault: '0xd3681b1F5cee2AFFa9883c09018Bf9552df4f07d',
        executor: '0x89072bDf6477394Cc52dC033D535F716E183b48E',
        chain: polygon,
        stargateId: 109,
        stargateRouter: '0x45A01E4e04F14f7A4a6702c74187c5F6222033cd',
        poolId: 1,
    },
    // [ChainId.FANTOM]: {
    //   name: 'Fantom',
    //   nativeCurrency: 'FTM',
    //   decimals: 18,
    //   rpcUrl: FANTOM_RPC_URL,
    //   nativeOracle: {
    //     address: '0xf4766552D15AE4d256Ad41B6cf2933482B0680dc',
    //     chainId: ChainId.FANTOM,
    //     decimals: 8,
    //   },
    //   permit2: '0x838c010F57889195C88f2097488e49B7ad04EcB1',
    //   pool: '0xBD1B1e1f33f89D4beCd0E5c6D3E88bd447992134',
    //   vault: '0xDCF998011dcAab9B8C1Ea5B34f1b6c7bAF59d4C0',
    //   executor: '0x0d528865620B97832f8CEeC78A6dA3Ce8F170F65',
    //   chain: fantom,
    //   stargateId: 112,
    //   stargateRouter: '0xAf5191B0De278C7286d6C7CC6ab6BB8A73bA2Cd6',
    //   poolId: 21,
    // },
    [ChainId.AVALANCHE]: {
        name: 'Avalanche',
        nativeCurrency: 'AVAX',
        decimals: 18,
        rpcUrl: AVALANCHE_RPC_URL,
        nativeOracle: {
            address: '0x0A77230d17318075983913bC2145DB16C7366156',
            chainId: ChainId.AVALANCHE,
            decimals: 8,
        },
        permit2: '0x000000000022D473030F116dDEE9F6B43aC78BA3',
        pool: '0xA86569F3E830E7dA020aA0041AD7df85fB1beC41',
        executor: '0xA8275f7dE9541C7373DDE0c4f659E6D4C0A5a0d5',
        vault: '0x8EbD59C02D1FCBF3dfDaDd0C29499dE9E159098f',
        chain: avalanche,
        stargateId: 106,
        stargateRouter: '0x45A01E4e04F14f7A4a6702c74187c5F6222033cd',
        poolId: 1,
    },
    [ChainId.ARBITRUM]: {
        name: 'Arbitrum',
        nativeCurrency: 'ETH',
        decimals: 18,
        rpcUrl: ARBITRUM_RPC_URL,
        nativeOracle: {
            address: '0x639Fe6ab55C921f74e7fac1ee960C0B6293ba612',
            chainId: ChainId.ARBITRUM,
            decimals: 8,
        },
        permit2: '0x000000000022D473030F116dDEE9F6B43aC78BA3',
        vault: '0xB804B16AA9cE18072b0d4B9c6CFfcC143aAAD4f1',
        executor: '0x22F20D8228824F7955869aCA766439a009f28Bdf',
        pool: '0x6b7B887B25776a96A759b315bc41F063106D862C',
        chain: arbitrum,
        stargateId: 110,
        stargateRouter: '0x53Bf833A5d6c4ddA888F69c22C88C9f356a41614',
        poolId: 1,
    },
    [ChainId.OPTIMISM]: {
        name: 'Optimism',
        nativeCurrency: 'ETH',
        decimals: 18,
        rpcUrl: OPTIMISM_RPC_URL,
        nativeOracle: {
            address: '0x13e3Ee699D1909E989722E753853AE30b17e08c5',
            chainId: ChainId.OPTIMISM,
            decimals: 8,
        },
        permit2: '0x000000000022D473030F116dDEE9F6B43aC78BA3',
        vault: '0x663264f051919B0eFF44F50Dd247Ad911b055630',
        executor: '0x6BC29542bE0647646DC6CfB96850150f4CE2D45e',
        pool: '0xBFD68d694FaC3aEeEeE8131A7229367172cee326',
        chain: optimism,
        stargateId: 111,
        stargateRouter: '0xB0D502E938ed5f4df2E681fE6E419ff29631d62b',
        poolId: 1,
    },
    [ChainId.BLAST]: {
        name: 'Blast',
        nativeCurrency: 'BLAST',
        decimals: 18,
        rpcUrl: BLAST_RPC_URL,
        nativeOracle: {
            address: '0x986b5E1e1755e3C2440e960477f25201B0a8bbD4',
            chainId: 1,
            decimals: 8,
        },
        permit2: '0x000000000022d473030f116ddee9f6b43ac78ba3',
        chain: blast,
    },
    [ChainId.BASE]: {
        name: 'Base',
        nativeCurrency: 'BASE',
        decimals: 18,
        rpcUrl: BASE_RPC_URL,
        nativeOracle: {
            address: '0x71041dddad3595F9CEd3DcCFBe3D1F4b0a16Bb70',
            chainId: ChainId.BASE,
            decimals: 8,
        },
        permit2: '0x000000000022D473030F116dDEE9F6B43aC78BA3',
        vault: '0x90A7e0E1F2e97d8a4C558C6e47b3228517d0bED5',
        executor: '0xA3372621d29e65fb1853BbeF2D78f63db135A2c2',
        pool: '0x4E3796048969D96fE7Df458F536F68eEfDCc41D3',
        chain: base,
        stargateId: 184,
        stargateRouter: '0x45f1A95A4D3f3836523F5c83673c797f4d4d263B',
        poolId: 1,
    },
    [ChainId.SOLANA]: {
        name: 'Solana',
        nativeCurrency: 'SOL',
        decimals: 9,
        rpcUrl: SOLANA_RPC_URL,
        executor: '75PwGLgZEWuGM9a3bVqXdmFjSUtE1Tms3767woyULnkR',
        pool: '75PwGLgZEWuGM9a3bVqXdmFjSUtE1Tms3767woyULnkR',
        nativeOracle: {
            address: '0x4ffC43a60e009B551865A93d232E33Fce9f01507',
            chainId: ChainId.ETHEREUM,
            decimals: 8,
        },
    },
    //DLN Solana
    [ChainId.SOLANA_DLN]: {
        [7565164]: {
            name: 'Solana',
            nativeCurrency: 'SOL',
            decimals: 9,
            rpcUrl: SOLANA_RPC_URL,
            executor: '75PwGLgZEWuGM9a3bVqXdmFjSUtE1Tms3767woyULnkR',
            pool: '75PwGLgZEWuGM9a3bVqXdmFjSUtE1Tms3767woyULnkR',
            nativeOracle: {
                address: '0x4ffC43a60e009B551865A93d232E33Fce9f01507',
                chainId: 1,
                decimals: 8,
            },
        },
        [ChainId.SOLANA_OKX]: {
            name: 'Solana',
            nativeCurrency: 'SOL',
            decimals: 9,
            rpcUrl: SOLANA_RPC_URL,
            executor: '75PwGLgZEWuGM9a3bVqXdmFjSUtE1Tms3767woyULnkR',
            pool: '75PwGLgZEWuGM9a3bVqXdmFjSUtE1Tms3767woyULnkR',
            nativeOracle: {
                address: '0x4ffC43a60e009B551865A93d232E33Fce9f01507',
                chainId: 1,
                decimals: 8,
            },
        },
        // [ChainId.SEPOLIA]: {
        //   name: "Sepolia",
        //   nativeCurrency: "sETH",
        //   decimals: 18,
        //   rpcUrl: "https://rpc.sepolia.io",
        // },
    },
};
export const V2Networks = {
    [ChainId.ETHEREUM]: {
        name: 'Ethereum',
        nativeCurrency: 'ETH',
        decimals: 18,
        rpcUrl: ETHEREUM_RPC_URL,
        permit2: '0x000000000022D473030F116dDEE9F6B43aC78BA3',
        chain: mainnet,
        stargateId: 101,
        stargateRouter: '0x8731d54E9D02c286767d56ac03e8037C07e01e98',
        poolId: 1,
        vault: '0x9a49a950607FE4FeaAD4b7CdC205eb13CAf0D32f',
        executor: '0x8754E1aC5C1483F9234eB27B71396eF3777dE313',
        nativeOracle: {
            address: '0x5f4eC3Df9cbd43714FE2740f5E3616155c5b8419',
            chainId: ChainId.ETHEREUM,
            decimals: 8,
        },
    },
    [ChainId.AVALANCHE]: {
        name: 'Avalanche',
        nativeCurrency: 'AVAX',
        decimals: 18,
        rpcUrl: AVALANCHE_RPC_URL,
        nativeOracle: {
            address: '0x0A77230d17318075983913bC2145DB16C7366156',
            chainId: ChainId.AVALANCHE,
            decimals: 8,
        },
        permit2: '0x000000000022D473030F116dDEE9F6B43aC78BA3',
        vault: '0x57Ba1239D1f7299ad6DF935597e4e69e2E555232',
        executor: '0xa3E0e461a148d5692cff0347Da6f974882D1ef48',
        chain: avalanche,
        stargateId: 106,
        stargateRouter: '0x45A01E4e04F14f7A4a6702c74187c5F6222033cd',
        poolId: 1,
    },
    [ChainId.OPTIMISM]: {
        name: 'Optimism',
        nativeCurrency: 'ETH',
        decimals: 18,
        rpcUrl: OPTIMISM_RPC_URL,
        nativeOracle: {
            address: '0x13e3Ee699D1909E989722E753853AE30b17e08c5',
            chainId: ChainId.OPTIMISM,
            decimals: 8,
        },
        permit2: '0x000000000022D473030F116dDEE9F6B43aC78BA3',
        vault: '0x1F2824dF56eBB0aC9D02395a923d12D773e38dF8',
        executor: '0xe81deac9e10E8cd7c3D0c93Cc6143bf0E5c35CE6',
        chain: optimism,
        stargateId: 111,
        stargateRouter: '0xB0D502E938ed5f4df2E681fE6E419ff29631d62b',
        poolId: 1,
    },
    [ChainId.BASE]: {
        name: 'Base',
        nativeCurrency: 'ETH',
        decimals: 18,
        rpcUrl: BASE_RPC_URL,
        nativeOracle: {
            address: '0x71041dddad3595F9CEd3DcCFBe3D1F4b0a16Bb70',
            chainId: ChainId.BASE,
            decimals: 8,
        },
        permit2: '0x000000000022D473030F116dDEE9F6B43aC78BA3',
        vault: '0x5B246B77A398E50d1647D85A6cfD2D6B8B57485f',
        executor: '0xd018745cD4A50Ed7B3d0f5ec6C36D475023C8506',
        chain: base,
        stargateId: 184,
        stargateRouter: '0x45f1A95A4D3f3836523F5c83673c797f4d4d263B',
        poolId: 1,
    },
    [ChainId.ARBITRUM]: {
        name: 'Arbitrum',
        nativeCurrency: 'ETH',
        decimals: 18,
        rpcUrl: ARBITRUM_RPC_URL,
        nativeOracle: {
            address: '0x639Fe6ab55C921f74e7fac1ee960C0B6293ba612',
            chainId: ChainId.ARBITRUM,
            decimals: 8,
        },
        permit2: '0x000000000022D473030F116dDEE9F6B43aC78BA3',
        vault: '0xa6dd8D3089e3E6D1Dc39e4A36E38EAebc791e6eD',
        executor: '0x336e8f43a4E80ec0ac745B60B11DB08d3B81A85e',
        chain: arbitrum,
        stargateId: 110,
        stargateRouter: '0x53Bf833A5d6c4ddA888F69c22C88C9f356a41614',
        poolId: 1,
    },
    [ChainId.BSC]: {
        name: 'Binance Smart Chain',
        nativeCurrency: 'BNB',
        decimals: 18,
        rpcUrl: BSC_RPC_URL,
        nativeOracle: {
            address: '0x0567F2323251f0Aab15c8dFb1967E4e8A7D42aeE',
            chainId: ChainId.BSC,
            decimals: 8,
        },
        permit2: '0x000000000022D473030F116dDEE9F6B43aC78BA3',
        vault: '0x92Ca25e45a0Dcb2C5df1EC17B687A0A009Cb3E04',
        executor: '0xc6e3c07f825599d040eBAA82448FF7C596645783',
        chain: bsc,
        stargateId: 102,
        stargateRouter: '0x4a364f8c717cAAD9A442737Eb7b8A55cc6cf18D8',
        poolId: 5,
    },
    [ChainId.POLYGON]: {
        name: 'Polygon',
        nativeCurrency: 'MATIC',
        decimals: 18,
        rpcUrl: POLYGON_RPC_URL,
        nativeOracle: {
            address: '0xAB594600376Ec9fD91F8e885dADF0CE036862dE0',
            chainId: ChainId.POLYGON,
            decimals: 8,
        },
        permit2: '0x000000000022D473030F116dDEE9F6B43aC78BA3',
        vault: '0x5949EE17a674c0706b3364191B516fb87268A32a',
        executor: '0xe02CD447b671B19a96b67225B16dc66dEb98E322',
        chain: polygon,
        stargateId: 109,
        stargateRouter: '0x45A01E4e04F14f7A4a6702c74187c5F6222033cd',
        poolId: 1,
    },
    [ChainId.SOLANA]: {
        name: 'Solana',
        nativeCurrency: 'SOL',
        decimals: 9,
        rpcUrl: SOLANA_RPC_URL,
        executor: '75PwGLgZEWuGM9a3bVqXdmFjSUtE1Tms3767woyULnkR',
        vault: '75PwGLgZEWuGM9a3bVqXdmFjSUtE1Tms3767woyULnkR',
        nativeOracle: {
            address: '0x4ffC43a60e009B551865A93d232E33Fce9f01507',
            chainId: ChainId.ETHEREUM,
            decimals: 8,
        },
    },
    //DLN Solana
    [ChainId.SOLANA_DLN]: {
        name: 'Solana',
        nativeCurrency: 'SOL',
        decimals: 9,
        rpcUrl: SOLANA_RPC_URL,
        executor: '75PwGLgZEWuGM9a3bVqXdmFjSUtE1Tms3767woyULnkR',
        vault: '75PwGLgZEWuGM9a3bVqXdmFjSUtE1Tms3767woyULnkR',
        nativeOracle: {
            address: '0x4ffC43a60e009B551865A93d232E33Fce9f01507',
            chainId: 1,
            decimals: 8,
        },
    },
    [ChainId.SOLANA_OKX]: {
        name: 'Solana',
        nativeCurrency: 'SOL',
        decimals: 9,
        rpcUrl: SOLANA_RPC_URL,
        executor: '75PwGLgZEWuGM9a3bVqXdmFjSUtE1Tms3767woyULnkR',
        vault: '75PwGLgZEWuGM9a3bVqXdmFjSUtE1Tms3767woyULnkR',
        nativeOracle: {
            address: '0x4ffC43a60e009B551865A93d232E33Fce9f01507',
            chainId: 1,
            decimals: 8,
        },
    },
};
export const SupportedNetworks = (protocolVersion = PROTOCOL_VERSION.V2) => {
    switch (protocolVersion) {
        case PROTOCOL_VERSION.LEGACY:
            return LegacyNetworks;
        case PROTOCOL_VERSION.V2:
            return LegacyNetworks;
    }
};
